import { Link } from "react-router-dom";
import { GraduationCap, ArrowRight } from "lucide-react";

export default function AcademyCta({ compact = false }) {
  if (compact) return <p className="text-sm text-slate-400" data-testid="academy-cta-inline">Want to run your own automotive business? <Link to="/university" className="text-[#60A5FA] hover:text-white underline underline-offset-4">Velocity Academy</Link> — a 24-week launch program.</p>;
  return (
    <section className="rounded-3xl border border-[#3B82F6]/30 bg-[#0B0F17] p-6 grid sm:grid-cols-[1fr_auto] gap-4 items-center" data-testid="academy-cta">
      <div>
        <p className="font-mono text-[11px] tracking-[0.2em] text-[#3B82F6] mb-1">VELOCITY ACADEMY</p>
        <h2 className="text-base md:text-lg font-semibold text-white">Build your automotive business.</h2>
        <p className="text-sm text-slate-400 mt-1">24 weeks from idea to launch plan — vehicle sales, rental fleets, transport, or shop operations.</p>
      </div>
      <Link to="/university" className="h-10 px-4 rounded-full bg-[#3B82F6] text-white text-sm font-semibold inline-flex items-center gap-2" data-testid="academy-cta-link"><GraduationCap className="w-4 h-4" />Request details <ArrowRight className="w-4 h-4" /></Link>
    </section>
  );
}
